import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import OrderNowButton, { Props } from '../_components/OrderNowButton';
import { NewPattern, NewDocument, OnSave } from '../../Sidebar/_actions/SidebarActions';
import { OnLayerAdd } from '../../LayerList/_actions/LayerListActions';
import { OnChangeStatus, OnChangeName } from '../../Document/_actions/DocumentActions';
import { SetOrderingStatus, OrderProduct, Toast } from '@af-common/UIData/_actions/UIDataActions';
import { DocumentStatusTypes } from '../../Document/_stores/DocumentStore';

const mapStateToProps = (store:Immutable.Record<any>, props: Props) => ({
	status: store.getIn(['create', 'document', 'status']),
	savedId: store.getIn(['create', 'document', 'savedId']),
	store: store,
});

const mapDispatchToProps = (dispatch: Dispatch, props: Props) => ({
	onSave: (fd: FormData) => dispatch(OnSave(fd)),
	setStatus: (status: DocumentStatusTypes) => dispatch(OnChangeStatus(status)),
	orderProduct: (id: string, productType: string) => dispatch(OrderProduct(id, productType)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderNowButton);